<template>
  <div class="task-child">
    <div class="report-image-grid" v-if="!loading">
      <CardSelect
        v-on:card-event="cardEvent($event)"
        :cards="cards"
        v-if="step===0"
      />
    </div>
    <div class="card-grid-item card-modal" v-else>
      <div class="block">
        <p class="circle">
          <span class="ouro ouro3">
            <span class="left">
              <span class="anim"></span>
            </span>
            <span class="right">
              <span class="anim"></span>
            </span>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { status_values, dash_tasks } from "../utils/env";
import CardSelect from './card/CardSelect'

export default {
  name: "CardSearch",
  components: {
      CardSelect
  },
  props: {
    task: { type: Object },
    header_status: { type: Object },
    footer_status: {type: Object},
    graphs: {type: Array},
    config: null,
    api: null
  },
  data: function() {
    return {
      status_values: status_values,
      dash_tasks: dash_tasks,
      cards: [],
      data_in: [],
      status: null,
      card: null,
      task_: this.task,
      header_status_: this.header_status,
      footer_status_: this.footer_status,
      loading: false,
      page_selected: 1,
      combo_initialized: false
    };
  },
  methods: {
    search: function() {
      this.load(true);
      if (this.text_filter !== null) {
        this.api
          .findCards(
            this.header_status_.root_combo_filter['value'],
            this.header_status_.text_filter,
            this.footer_status_.page_selected
          )
          .then(
            response => {
              var data = response.data;
              this.cards = data["results"]["hits"]["hits"];
              this.footer_status_.paginator = data['paging-filter']['paginator'];
              this.data_in = data;
              this.load(false);
            },
            error => {
              console.log(error);
              this.load(false);
            }
          );
      }
    },
    searchGraphs: function() {
        let data = this.graphs;
        let data_ = data.map(res => {
          let elem_ = { value: res["graphid"], key: res["name"] };
          elem_["children"] = [];
          return elem_;
        });
        this.header_status_.combo_filter_values = data_;
        this.header_status_.text_filter = ""; 
        this.header_status_.root_combo_filter = "";
        this.header_status_.leaf_combo_filter = "";
        this.$root.header_status = this.header_status_;
        this.combo_initialized = true;
    },
    cardEvent: function(event) {
      switch (event.topic) {
        case "card-edit":
          this.card = event.card;
          window.open(
              `/resource/${event.card._source.resourceinstanceid}`,
              "_blank"
              );
          break;
        case "card-report":
          this.card = event.card;
          window.open(
              `/report/${event.card._source.resourceinstanceid}`,
              "_blank"
              );
          break;
      }
    },
    load(value) {
      this.loading = value;
    }
  },
  computed: {
    step: {
      get() {
        return this.task_.workflow_current_index;
      },
      set(value) {
        this.task_.workflow_current_index = value;
        if (this.step == 0) this.searchGraphs();
        this.$emit("dash-event", {
          topic: "workflow-current-index",
          workflow_current_index: value
        });
      }
    }
  },
  watch: {
    step: function() {
      if (this.step === 0) {
        this.card = null;
        this.combo_initialized = false;
        this.searchGraphs();
        // this.search();
      }
    },
    header_status: {
      handler() {
        if  (this.step === 0 && this.combo_initialized) this.search();
      },
      deep: true
    },
    'footer_status_.root_combo_filter': {
      handler() {
        if( (this.footer_status_) &&
            ('page_selected' in this.footer_status_)) {
              this.search();
            }
      },
      deep: true
    },
    'footer_status_.page_selected': {
      handler()  {
        this.search();
      },
      deep: true
    }
  },
  mounted: function() {
    this.step = 0;
  }
};
</script>

<style scoped>
.workflow-child {
  min-height: 240px;
  padding-left: 60px;
}

.panel-heading {
  height: 50px;
  margin-top: 0px !important;
  padding: 2px 2px 2px 2px;
  background-color: #ffffff;
  border-width: 0px 0px 0px 0px;
  border-style: solid;
  border-color: #ffffff;
}

.panel-footer {
  border-width: 0px 0px 0px 0px;
  border-color: #000000;
  border-style: solid;
}

.panel-body {
  border: 1px solid;
  border-color: #9e5757;
}

button.btn {
  margin: 10px;
  float: left;
}

.panel-heading button {
  float: left;
  margin: 4px;
}

.panel-heading > a {
  border-width: 0px 0px 0px 1px;
  border-color: #ffffff;
  border-style: solid;
}

.panel-heading > div {
  border-width: 0px 0px 0px 0px;
  border-color: #ffffff;
  border-style: solid;
}

.panel-heading > div > a {
  height: 30px;
  padding: 4px 6px;
}
.panel-heading button.btn {
  top: 4px;
  padding: 4px 4px 4px 4px;
}

.form-control {
  max-width: 160px;
  margin-left: 4px;
}

div.well {
  padding: 4px 4px 4px 4px;
  max-height: 36px;
  width: 400px;
  margin: 2px 2px 2px 2px;
  vertical-align: middle;
  font-size: 16px;
}

div.well > * {
  max-height: 36px;
  margin: 4px 4px 4px 4px;
}

div[class^="col-"] {
  padding: 2px 2px 2px 2px;
}

div#app .form-control {
  max-width: 100%;
}

.card-grid-item {
  width: 400px;
  text-overflow: ellipsis;
  word-wrap: break-word;
  padding-bottom: 0px;
}
.car-grid-item * {
  display: block;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.panel-body {
  min-height: 251px;
}

.addScroll {
  overflow-y: auto;
  height: 200px;
}

.card-grid-item.card-modal {
  min-height: 240px;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.1);
  text-align: center;
  display: table;
  width: 100%;
  border: 0px;
}

#app .block {
  display: table-cell;
  vertical-align: middle;
  background-color: rgba(255, 255, 255, 0.1);
}
</style>

